"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearfixHelperStyle = void 0;

var _utils = require("../../utils");

var _templateObject;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var clearfixHelperStyle = (0, _utils.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  &:after {\n    height: 0;\n    display: table;\n    content: '';\n    clear: both;\n  }\n"])));
exports.clearfixHelperStyle = clearfixHelperStyle;